import React from "react";
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { withTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';
import "./Landing.css"
class Landing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        };
        this.carouselRef = React.createRef();
    }

    componentDidMount() {
        const carouselElement = this.carouselRef.current;
        const bootstrap = require('bootstrap');

        // Initialize the Bootstrap Carousel
        this.carouselInstance = new bootstrap.Carousel(carouselElement, {
            interval: 5000,
        });

        carouselElement.addEventListener('slid.bs.carousel', (event) => {
            const index = event.to;
            this.setState({ activeIndex: index });
        });
    }

    handlePrev = () => {
        this.carouselInstance.prev();
    };

    handleNext = () => {
        this.carouselInstance.next();
    };

    render() {
        const { activeIndex } = this.state;
        const { t } = this.props;

        return (
            <div className="container-fluid p-0 min-vh-100">
                <div className="row no-gutters min-vh-100">
                    {/* Left column (logo + actions) */}
                    <div className="col-12 col-md-5 d-flex flex-column justify-content-center align-items-center text-center order-1 order-md-2 mobile-logo-top" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                        <div>
                            <LanguageSwitcher style={{
                                position: "absolute",
                                top: 8,
                                right: 12
                            }} />
                        </div>
                        <div className="logo-container logo-lg">
                            <img
                                src={process.env.PUBLIC_URL + "/images/spare_logo_s.png"}
                                alt="Spare Logo"
                                className="responsive-image"
                                style={{ maxWidth: '25%' }}
                            />
                        </div>

                        <div className="container">
                            <div className="spare-dvs d-flex flex-column justify-content-center align-items-center">
                                <div className="w-100 text-center">
                                    <div className="mb-3"></div>
                                    <div>
                                        <span>
                                            <h3 className="d-none d-md-block" style={{ fontWeight: 'bold', fontSize: '20px', paddingBottom: '15px' }}>
                                                {t('landing:welcome')}
                                            </h3>

                                            <div className="log-form mt-2 d-none d-md-block">
                                                <Link to="/login" className="log-btn" style={{ textDecoration: 'none', padding: '6px', marginTop: '0px' }}>
                                                    {t('landing:login')}
                                                </Link>
                                            </div>
                                            <div className="log-form mt-2 d-none d-md-block">
                                                <Link to="/signup" className="log-btn custom-signup-btn" style={{ textDecoration: 'none', padding: '6px', marginTop: '0px' }}>
                                                    {t('landing:signup')}
                                                </Link>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right column (carousel) */}
                    <div className="custom-gradient-div col-12 col-md-7 d-flex flex-column justify-content-center align-items-center order-2 order-md-1">
                        {/* Small-screen logo */}
                        <div className="logo-container logo-sm" style={{ position: 'absolute', top: '10px', zIndex: 1000 }}>
                            <img
                                src={process.env.PUBLIC_URL + "/images/spare_logo_s.png"}
                                alt="Spare Logo"
                                className="responsive-image"
                                style={{ maxWidth: '30%' }}
                            />
                        </div>

                        <div className="w-100 text-center">
                            <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel" ref={this.carouselRef}>
                                <div className="w-100 text-center" style={{ marginTop: '60px' }}>
                                    <div
                                        id="carouselExampleCaptions"
                                        className="carousel slide onboarding-carousel"
                                        data-bs-ride="carousel"
                                        ref={this.carouselRef}
                                    >
                                        <div style={{ width: '100%' }}>
                                            <div className="carousel-inner">

                                                {/* Slide 1 (make one item active) */}
                                                <div className="carousel-item active">
                                                    <div className="d-flex flex-column align-items-center slide-content">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/images/onboarding1@4x.png"}
                                                            className="d-block w-auto carousel-img"
                                                            alt={t('landing:slides.s1.alt')}
                                                            style={{ marginBottom: "10px" }}
                                                        />
                                                        <div className="text-center slide-body">
                                                            <h5 style={{ color: '#000' }}>
                                                                {t('landing:slides.s1.titleTop')}
                                                                <span style={{ display: 'block' }}>{t('landing:slides.s1.titleBottom')}</span>
                                                            </h5>
                                                            <span style={{ fontSize: '0.875rem' }}>{t('landing:slides.s1.body1')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s1.body2')}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Slide 2 */}
                                                <div className="carousel-item">
                                                    <div className="d-flex flex-column align-items-center slide-content">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/images/onboarding2@4x.png"}
                                                            className="d-block w-auto carousel-img"
                                                            alt={t('landing:slides.s2.alt')}
                                                            style={{ marginBottom: "10px" }}
                                                        />
                                                        <div className="text-center slide-body">
                                                            <h5 style={{ color: '#000' }}>{t('landing:slides.s2.title')}</h5>
                                                            <span style={{ fontSize: '0.875rem' }}>{t('landing:slides.s2.body1')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s2.body2')}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Slide 3 */}
                                                <div className="carousel-item">
                                                    <div className="d-flex flex-column align-items-center slide-content">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/images/onboarding3@4x.png"}
                                                            className="d-block w-auto carousel-img"
                                                            alt={t('landing:slides.s3.alt')}
                                                            style={{ marginBottom: "10px" }}
                                                        />
                                                        <div className="text-center slide-body">
                                                            <h5 style={{ color: '#000' }}>{t('landing:slides.s3.title')}</h5>
                                                            <span style={{ fontSize: '0.875rem' }}>{t('landing:slides.s3.body1')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s3.body2')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s3.body3')}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Slide 4 */}
                                                <div className="carousel-item">
                                                    <div className="d-flex flex-column align-items-center slide-content">
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/images/onboarding4@4x.png"}
                                                            className="d-block w-auto carousel-img"
                                                            alt={t('landing:slides.s4.alt')}
                                                            style={{ marginBottom: "10px" }}
                                                        />
                                                        <div className="text-center slide-body">
                                                            <h5 style={{ color: '#000' }}>
                                                                {t('landing:slides.s4.titleTop')}
                                                                <span style={{ display: 'block' }}>{t('landing:slides.s4.titleBottom')}</span>
                                                            </h5>
                                                            <span style={{ fontSize: '0.875rem' }}>{t('landing:slides.s4.body1')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s4.body2')}</span>
                                                            <span style={{ fontSize: '0.875rem', display: 'block' }}>{t('landing:slides.s4.body3')}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Progress Indicator with Previous and Next Buttons */}
                                <div className="d-flex justify-content-center align-items-center mb-3">
                                    {/* <button className="custom-prev-btn" onClick={this.handlePrev}>
                                        <img src={process.env.PUBLIC_URL + "/images/left arrow@1x.png"} alt={t('landing:carousel.prev')} />
                                    </button> */}

                                    <div className="progress-indicator-container d-flex justify-content-center align-items-center" aria-label={t('landing:carousel.progressAria')}>
                                        {[0, 1, 2, 3].map((index) => (
                                            <span
                                                key={index}
                                                className="progress-indicator"
                                                style={{
                                                    backgroundColor: activeIndex === index ? '#4C6EF8' : 'white',
                                                    width: '25px',
                                                    height: '7px',
                                                    borderRadius: '5px',
                                                    margin: '0 3px'
                                                }}
                                            ></span>
                                        ))}
                                    </div>

                                    {/* <button className="custom-next-btn" onClick={this.handleNext}>
                                        <img src={process.env.PUBLIC_URL + "/images/right arrow@1x.png"} alt={t('landing:carousel.next')} />
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Buttons for smaller screens */}
                    <div className="col-12 d-md-none" style={{ padding: '20px' }}>
                        <span className="log-form-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                            <span className="log-form mt-2" style={{ width: '80%' }}>
                                <button
                                    type="button"
                                    className="action-button btn"
                                    style={{ textDecoration: 'none', padding: '6px', marginTop: '0px', width: '100%' }}
                                    onClick={() => this.props.history.push('/login')}
                                >
                                    {t('landing:login')}
                                </button>
                            </span>

                            {/* change the links to buttons but maintain the navigation feature */}
                            <span className="log-form mt-2" style={{ width: '80%' }}>
                                <button
                                    type="button"
                                    className="action-button btn"
                                    style={{ textDecoration: 'none', padding: '6px', marginTop: '15px', width: '100%' }}
                                    onClick={() => this.props.history.push('/signup')}
                                >
                                    {t('landing:signup')}
                                </button>
                            </span>
                        </span>
                    </div>

                </div>
            </div>
        );
    }
}

export default withTranslation(['landing'])(Landing);
